import React from "react";
import { Button, SwitchStyled, Text } from "@commonsku/styles";

export default function CategoryImages(props) {
  const { value, onChange, onClick } = props;

  return (
    <>
      <Text
        as="p"
        style={{
          color: "var(--color-neutrals-90)",
          fontFamily: "var(--font-family-bold)",
          fontSize: 20,
          marginBottom: 0,
        }}
      >
        Categories
      </Text>
      <Button
        variant="primary"
        size="medium"
        style={{ width: "100%", marginBottom: 14, marginTop: 7 }}
        onClick={onClick}
        data-testid="edit_category_images_btn"
      >
        Edit Category Images
      </Button>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Text
          as="p"
          style={{
            color: "var(--color-neutrals-90)",
            fontFamily: "var(--font-family-regular)",
            fontSize: 16,
            marginBottom: 0,
            width: 144,
          }}
        >
          Show Category Title
        </Text>
        <SwitchStyled
          size="medium"
          selected={+value === 1}
          onClick={() => onChange(+value !== 1 ? 1 : 0)}
          data-testid="show_category_title_toggle"
        />
      </div>
    </>
  );
}
